/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Formikform from "../../../../Components/ExtraComponents/Form/Formik_form1";
import { useFormik } from "formik";
import * as valid_err from "../../../../Utils/Common_Messages";
// import { toast } from "react-toastify";
import {
  BrowserRouter,
  Route,
  Routes,
  NavLink,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  Email_regex,
  Mobile_regex,
  No_Negetive_Input_regex,
} from "../../../../Utils/Common_regex";
import { useDispatch, useSelector } from "react-redux";
import Content from "../../../../Components/Dashboard/Content/Content";
import { Get_All_Catagory } from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import toast, { Toaster } from "react-hot-toast";

import ToastButton from "../../../../Components/ExtraComponents/Alert_Toast";

import { Add_Strategy } from "../../../../ReduxStore/Slice/Admin/StrategySlice";

const AddStraegyNormal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const AdminToken = JSON.parse(localStorage.getItem("user_details")).token;
  const user_details = JSON.parse(localStorage.getItem("user_details"));

  const formik = useFormik({
    initialValues: {
      strategyname: "",
      perlot: "",
      Catagory: "Crypto",
      segment: "",
      indecator: "",
      strategytester: "",
      strategy_description: "",
      starategylogo: "",
      Add_by: "",
    },
    validate: (values) => {
      const errors = {};

      if (!values.strategyname) {
        errors.strategyname = valid_err.EMPTY_STRATEGY_NAME_ERR;
      }

      if (!values.strategy_description) {
        errors.strategy_description = valid_err.EMPTY_STRATEGY_DESCRIPTION_ERR;
      } else if (values.strategy_description.length < 100) {
        errors.strategy_description = "Description must be at least 100 characters long.";
      }

      return errors;
    },

    onSubmit: async (values) => {
      const req = {
        strategy_name: values.strategyname,
        strategy_segment: "Crypto",
        strategy_description: values.strategy_description,
        Add_by: user_details.user_id,
         strategy_image: values.starategylogo,
        strategy_indicator: values.indecator,
      };

      await dispatch(Add_Strategy({ req: req, token: AdminToken }))
        .unwrap()
        .then((response) => {
          if (response.status) {
            toast.success(response.msg);
            setTimeout(() => {
              navigate("/subadmin/strategies");
            }, 1000);
          } else {
            toast.error(response.msg);
          }
        });
    },
  });
   const indicatorList = [
    "RSI",
    "BollingerBand",
    "Supertrend",
    "Moving Average",
    "MACD",
    "Parabolic SAR",
    "Fractals",
    "Stochastic Oscillator",
    "ATR",
    "Envelopes",
  ];

  const fields = [
    {
      name: "strategyname",
      label: "Strategy Name",
      type: "text",
      label_size: 6,
      col_size: 6,
      disable: false,
    },
     {
      name: "indecator",
      label: "Strategy Indicator",
      type: "text",
      col_size: 6,
      label_size: 6,
      list: "indicator-list",   // 👈 dropdown attach
    },
    
    {
      name: "starategylogo",
      label: "Strategy Logo (Image)",
      type: "file",
      col_size: 12,
      label_size: 12
    },

    {
      name: "strategy_description",
      label: "Strategy Description",
      type: "msgbox",
      row_size: 7,
      label_size: 12,
      col_size: 12,
      disable: false,
    },
  ];

  return (
    <>
      <Content
        Page_title="Add Strategy "
        button_title="Back"
        route="/subadmin/strategies"
      >
        <Formikform
          fieldtype={fields.filter(
            (field) => !field.showWhen || field.showWhen(formik.values)
          )}
          formik={formik}
          btn_name="Add Strategy"
          title="addstrategy"
        />
        <ToastButton />
      </Content>
    </>
  );
};

export default AddStraegyNormal;
